import styled from 'styled-components'

export const YoutubePlayerPopupWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  iframe {
    width: 100vw;
    height: 100vh;
  }
`

export const YouTubePlayerWrapper = styled.div`
  position: relative;
  width: 1296px;
  height: 600px;
  margin: 8px 8px 20px;

  iframe {
    width: 1296px;
    height: 600px;
  }
`
